export const environment = {
    production: true,
    auto_fill: false,
    hmr: false,
    banner: `Base DEV .NET8`,
    version: '2026.0908.0955',

    BaseAvatarUrl: 'https://devbase.tibiqit.dev/assets/images/PoradciObr',
    BaseApiUrl: 'https://devbaseapi.tibiqit.dev/api',
    BaseAdvisorUrl: 'https://devbase.tibiqit.dev/assets/images/PoradciObr',
    ApolloUrl: 'https://devapollo.tibiqit.dev',
    PortalUrl: 'https://devsso.siriusfinance.cz',

    SsoUrl: 'https://devsso.siriusfinance.cz',
    SsoAllowedUrls: ['https://devsso.siriusfinance.cz/', 'https://devbaseapi.tibiqit.dev/', 'http://localhost:5000/'],
    SsoClientId: 'app-test-client',
    SsoDummyClientSecret: 'BeyKUpe9JA50L9e3rceZNF4BskIvtNmCzb6d1nvgxZAQ',
    SsoScope: 'openid profile roles advisor api_base offline_access',
};
